export const queryMyProjectsSections = `{
    myProjectsSections {
      id
      projectName
      aboutProject
      demonstrationGif
      githubLink
      publicateLink
      info
      technologies {
        name
        imageUrl
      }
    }
  }`
  

  